import React from 'react';
import { Box, Button, Paper, Typography, useTheme } from '@mui/material';
import { IconChartBar } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';

const DashboardGerencialWidget = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/dashboard/metrics');
  };

  return (
    <Box sx={{ mb: 2, px: 2 }}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'hidden',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
            transform: 'translateY(-2px)'
          }
        }}
      >
        <Button
          fullWidth
          onClick={handleNavigate}
          sx={{
            justifyContent: 'flex-start',
            py: 2.5,
            px: 2.5,
            textTransform: 'none',
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: 'transparent'
            }
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              width: '100%'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: 1.5,
                backgroundColor: `${theme.palette.primary.main}15`,
                transition: 'all 0.2s ease-in-out',
                '.MuiButton-root:hover &': {
                  backgroundColor: `${theme.palette.primary.main}25`
                }
              }}
            >
              <IconChartBar size="1.3rem" color={theme.palette.primary.main} />
            </Box>
            <Box sx={{ textAlign: 'left', flex: 1 }}>
              <Typography
                variant="body1"
                fontWeight={600}
                sx={{
                  color: theme.palette.text.primary,
                  mb: 0.25
                }}
              >
                Dashboard Gerencial
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: theme.palette.text.secondary,
                  display: 'block'
                }}
              >
                Ver métricas y análisis
              </Typography>
            </Box>
          </Box>
        </Button>
      </Paper>
    </Box>
  );
};

export default DashboardGerencialWidget;
